import { useReducer } from 'react'

const reducer = (state, action) => {
  switch (action.type) {
    case 'error':
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    case 'reset':
      return {
        ...state,
        value: action.defaultValue,
      }
    case 'value':
      return {
        ...state,
        loading: false,
        value: action.value,
      }
    default:
      return state
  }
}

const useLoadingValue = (defaultValue) => {
  const [state, dispatch] = useReducer(reducer, {
    loading: defaultValue === undefined || defaultValue === null,
    value: defaultValue,
  })

  const reset = () => dispatch({ type: 'reset', defaultValue })

  const setError = error => dispatch({ type: 'error', error })

  const setValue = value => dispatch({ type: 'value', value })

  return {
    error: state.error,
    loading: state.loading,
    reset,
    setError,
    setValue,
    value: state.value,
  }
}

export default useLoadingValue
